import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { applyStoredTheme } from './stores/ui.store';
import App from './App';

// Apply theme before first render to avoid flash of wrong theme
applyStoredTheme();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
